/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as SplatRouteImport } from './routes/$';
import { Route as AppLayoutRouteImport } from './routes/_app/layout';
import { Route as PublicLayoutRouteImport } from './routes/_public/layout';
import { Route as AppBidraRouteImport } from './routes/_app/bidra';
import { Route as AppMittKontoLayoutRouteImport } from './routes/_app/mitt-konto/layout';
import { Route as PublicAuthLayoutRouteImport } from './routes/_public/_auth/layout';
import { Route as PublicEPostVerifieradRouteImport } from './routes/_public/e-post-verifierad';
import { Route as PublicOmLayoutRouteImport } from './routes/_public/om/layout';
import { Route as PublicUpplevelserLayoutRouteImport } from './routes/_public/upplevelser/layout';
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index';
import { Route as AppAdminLaggTillPlatsRouteImport } from './routes/_app/admin/lagg-till-plats';
import { Route as AppKartaIndexRouteImport } from './routes/_app/karta/index';
import { Route as AppMittKontoIndexRouteImport } from './routes/_app/mitt-konto/index';
import { Route as AppMittKontoAndraEpostRouteImport } from './routes/_app/mitt-konto/andra-epost';
import { Route as AppMittKontoAndraLosenordRouteImport } from './routes/_app/mitt-konto/andra-losenord';
import { Route as AppMittKontoRaderaKontoRouteImport } from './routes/_app/mitt-konto/radera-konto';
import { Route as AppMittKontoRedigeraProfilRouteImport } from './routes/_app/mitt-konto/redigera-profil';
import { Route as AppPlatsIdRouteImport } from './routes/_app/plats/$id';
import { Route as AppRapporteraIndexRouteImport } from './routes/_app/rapportera/index';
import { Route as AppTopplistaIndexRouteImport } from './routes/_app/topplista/index';
import { Route as AppUpptackIndexRouteImport } from './routes/_app/upptack/index';
import { Route as AppUpptackSlugRouteImport } from './routes/_app/upptack/$slug';
import { Route as PublicAuthAterstallLosenordRouteImport } from './routes/_public/_auth/aterstall-losenord';
import { Route as PublicAuthBegarAterstallLosenordRouteImport } from './routes/_public/_auth/begar-aterstall-losenord';
import { Route as PublicAuthLoggaInRouteImport } from './routes/_public/_auth/logga-in';
import { Route as PublicAuthSkapaKontoRouteImport } from './routes/_public/_auth/skapa-konto';
import { Route as PublicOmIntegritetRouteImport } from './routes/_public/om/integritet';
import { Route as PublicOmVillkorRouteImport } from './routes/_public/om/villkor';
import { Route as PublicUpplevelserIndexRouteImport } from './routes/_public/upplevelser/index';
import { Route as PublicUpplevelserSlugRouteImport } from './routes/_public/upplevelser/$slug';
import { Route as PublicUpplevelserSokRouteImport } from './routes/_public/upplevelser/sok';
import { Route as AppAdminFeatureIdRouteImport } from './routes/_app/admin/feature/$id';
import { Route as AppAdminGranskaIndexRouteImport } from './routes/_app/admin/granska/index';
import { Route as AppAdminPlatserIdRouteImport } from './routes/_app/admin/platser/$id';
import { Route as AppUpptackRedigeraSlugRouteImport } from './routes/_app/upptack/redigera/$slug';
import { Route as PublicUpplevelserKategoriSlugRouteImport } from './routes/_public/upplevelser/kategori.$slug';
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport
});
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport
});
const AppLayoutRoute = AppLayoutRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport
});
const PublicLayoutRoute = PublicLayoutRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport
});
const AppBidraRoute = AppBidraRouteImport.update({
  id: '/bidra',
  path: '/bidra',
  getParentRoute: () => AppLayoutRoute
});
const AppMittKontoLayoutRoute = AppMittKontoLayoutRouteImport.update({
  id: '/mitt-konto',
  path: '/mitt-konto',
  getParentRoute: () => AppLayoutRoute
});
const PublicAuthLayoutRoute = PublicAuthLayoutRouteImport.update({
  id: '/_auth',
  getParentRoute: () => PublicLayoutRoute
});
const PublicEPostVerifieradRoute = PublicEPostVerifieradRouteImport.update({
  id: '/e-post-verifierad',
  path: '/e-post-verifierad',
  getParentRoute: () => PublicLayoutRoute
});
const PublicOmLayoutRoute = PublicOmLayoutRouteImport.update({
  id: '/om',
  path: '/om',
  getParentRoute: () => PublicLayoutRoute
});
const PublicUpplevelserLayoutRoute = PublicUpplevelserLayoutRouteImport.update({
  id: '/upplevelser',
  path: '/upplevelser',
  getParentRoute: () => PublicLayoutRoute
});
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AppLayoutRoute
});
const AppAdminLaggTillPlatsRoute = AppAdminLaggTillPlatsRouteImport.update({
  id: '/admin/lagg-till-plats',
  path: '/admin/lagg-till-plats',
  getParentRoute: () => AppLayoutRoute
});
const AppKartaIndexRoute = AppKartaIndexRouteImport.update({
  id: '/karta/',
  path: '/karta/',
  getParentRoute: () => AppLayoutRoute
});
const AppMittKontoIndexRoute = AppMittKontoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMittKontoLayoutRoute
});
const AppMittKontoAndraEpostRoute = AppMittKontoAndraEpostRouteImport.update({
  id: '/andra-epost',
  path: '/andra-epost',
  getParentRoute: () => AppMittKontoLayoutRoute
});
const AppMittKontoAndraLosenordRoute = AppMittKontoAndraLosenordRouteImport.update({
  id: '/andra-losenord',
  path: '/andra-losenord',
  getParentRoute: () => AppMittKontoLayoutRoute
});
const AppMittKontoRaderaKontoRoute = AppMittKontoRaderaKontoRouteImport.update({
  id: '/radera-konto',
  path: '/radera-konto',
  getParentRoute: () => AppMittKontoLayoutRoute
});
const AppMittKontoRedigeraProfilRoute = AppMittKontoRedigeraProfilRouteImport.update({
  id: '/redigera-profil',
  path: '/redigera-profil',
  getParentRoute: () => AppMittKontoLayoutRoute
});
const AppPlatsIdRoute = AppPlatsIdRouteImport.update({
  id: '/plats/$id',
  path: '/plats/$id',
  getParentRoute: () => AppLayoutRoute
});
const AppRapporteraIndexRoute = AppRapporteraIndexRouteImport.update({
  id: '/rapportera/',
  path: '/rapportera/',
  getParentRoute: () => AppLayoutRoute
});
const AppTopplistaIndexRoute = AppTopplistaIndexRouteImport.update({
  id: '/topplista/',
  path: '/topplista/',
  getParentRoute: () => AppLayoutRoute
});
const AppUpptackIndexRoute = AppUpptackIndexRouteImport.update({
  id: '/upptack/',
  path: '/upptack/',
  getParentRoute: () => AppLayoutRoute
});
const AppUpptackSlugRoute = AppUpptackSlugRouteImport.update({
  id: '/upptack/$slug',
  path: '/upptack/$slug',
  getParentRoute: () => AppLayoutRoute
});
const PublicAuthAterstallLosenordRoute = PublicAuthAterstallLosenordRouteImport.update({
  id: '/aterstall-losenord',
  path: '/aterstall-losenord',
  getParentRoute: () => PublicAuthLayoutRoute
});
const PublicAuthBegarAterstallLosenordRoute = PublicAuthBegarAterstallLosenordRouteImport.update({
  id: '/begar-aterstall-losenord',
  path: '/begar-aterstall-losenord',
  getParentRoute: () => PublicAuthLayoutRoute
});
const PublicAuthLoggaInRoute = PublicAuthLoggaInRouteImport.update({
  id: '/logga-in',
  path: '/logga-in',
  getParentRoute: () => PublicAuthLayoutRoute
});
const PublicAuthSkapaKontoRoute = PublicAuthSkapaKontoRouteImport.update({
  id: '/skapa-konto',
  path: '/skapa-konto',
  getParentRoute: () => PublicAuthLayoutRoute
});
const PublicOmIntegritetRoute = PublicOmIntegritetRouteImport.update({
  id: '/integritet',
  path: '/integritet',
  getParentRoute: () => PublicOmLayoutRoute
});
const PublicOmVillkorRoute = PublicOmVillkorRouteImport.update({
  id: '/villkor',
  path: '/villkor',
  getParentRoute: () => PublicOmLayoutRoute
});
const PublicUpplevelserIndexRoute = PublicUpplevelserIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicUpplevelserLayoutRoute
});
const PublicUpplevelserSlugRoute = PublicUpplevelserSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => PublicUpplevelserLayoutRoute
});
const PublicUpplevelserSokRoute = PublicUpplevelserSokRouteImport.update({
  id: '/sok',
  path: '/sok',
  getParentRoute: () => PublicUpplevelserLayoutRoute
});
const AppAdminFeatureIdRoute = AppAdminFeatureIdRouteImport.update({
  id: '/admin/feature/$id',
  path: '/admin/feature/$id',
  getParentRoute: () => AppLayoutRoute
});
const AppAdminGranskaIndexRoute = AppAdminGranskaIndexRouteImport.update({
  id: '/admin/granska/',
  path: '/admin/granska/',
  getParentRoute: () => AppLayoutRoute
});
const AppAdminPlatserIdRoute = AppAdminPlatserIdRouteImport.update({
  id: '/admin/platser/$id',
  path: '/admin/platser/$id',
  getParentRoute: () => AppLayoutRoute
});
const AppUpptackRedigeraSlugRoute = AppUpptackRedigeraSlugRouteImport.update({
  id: '/upptack/redigera/$slug',
  path: '/upptack/redigera/$slug',
  getParentRoute: () => AppLayoutRoute
});
const PublicUpplevelserKategoriSlugRoute = PublicUpplevelserKategoriSlugRouteImport.update({
  id: '/kategori/$slug',
  path: '/kategori/$slug',
  getParentRoute: () => PublicUpplevelserLayoutRoute
});
const AppMittKontoLayoutRouteChildren = {
  AppMittKontoAndraEpostRoute: AppMittKontoAndraEpostRoute,
  AppMittKontoAndraLosenordRoute: AppMittKontoAndraLosenordRoute,
  AppMittKontoRaderaKontoRoute: AppMittKontoRaderaKontoRoute,
  AppMittKontoRedigeraProfilRoute: AppMittKontoRedigeraProfilRoute,
  AppMittKontoIndexRoute: AppMittKontoIndexRoute
};
const AppMittKontoLayoutRouteWithChildren = AppMittKontoLayoutRoute._addFileChildren(AppMittKontoLayoutRouteChildren);
const AppLayoutRouteChildren = {
  AppMittKontoLayoutRoute: AppMittKontoLayoutRouteWithChildren,
  AppBidraRoute: AppBidraRoute,
  AppAdminLaggTillPlatsRoute: AppAdminLaggTillPlatsRoute,
  AppPlatsIdRoute: AppPlatsIdRoute,
  AppUpptackSlugRoute: AppUpptackSlugRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppKartaIndexRoute: AppKartaIndexRoute,
  AppRapporteraIndexRoute: AppRapporteraIndexRoute,
  AppTopplistaIndexRoute: AppTopplistaIndexRoute,
  AppUpptackIndexRoute: AppUpptackIndexRoute,
  AppAdminFeatureIdRoute: AppAdminFeatureIdRoute,
  AppAdminPlatserIdRoute: AppAdminPlatserIdRoute,
  AppUpptackRedigeraSlugRoute: AppUpptackRedigeraSlugRoute,
  AppAdminGranskaIndexRoute: AppAdminGranskaIndexRoute
};
const AppLayoutRouteWithChildren = AppLayoutRoute._addFileChildren(AppLayoutRouteChildren);
const PublicAuthLayoutRouteChildren = {
  PublicAuthAterstallLosenordRoute: PublicAuthAterstallLosenordRoute,
  PublicAuthBegarAterstallLosenordRoute: PublicAuthBegarAterstallLosenordRoute,
  PublicAuthLoggaInRoute: PublicAuthLoggaInRoute,
  PublicAuthSkapaKontoRoute: PublicAuthSkapaKontoRoute
};
const PublicAuthLayoutRouteWithChildren = PublicAuthLayoutRoute._addFileChildren(PublicAuthLayoutRouteChildren);
const PublicOmLayoutRouteChildren = {
  PublicOmIntegritetRoute: PublicOmIntegritetRoute,
  PublicOmVillkorRoute: PublicOmVillkorRoute
};
const PublicOmLayoutRouteWithChildren = PublicOmLayoutRoute._addFileChildren(PublicOmLayoutRouteChildren);
const PublicUpplevelserLayoutRouteChildren = {
  PublicUpplevelserSlugRoute: PublicUpplevelserSlugRoute,
  PublicUpplevelserSokRoute: PublicUpplevelserSokRoute,
  PublicUpplevelserIndexRoute: PublicUpplevelserIndexRoute,
  PublicUpplevelserKategoriSlugRoute: PublicUpplevelserKategoriSlugRoute
};
const PublicUpplevelserLayoutRouteWithChildren = PublicUpplevelserLayoutRoute._addFileChildren(PublicUpplevelserLayoutRouteChildren);
const PublicLayoutRouteChildren = {
  PublicAuthLayoutRoute: PublicAuthLayoutRouteWithChildren,
  PublicOmLayoutRoute: PublicOmLayoutRouteWithChildren,
  PublicUpplevelserLayoutRoute: PublicUpplevelserLayoutRouteWithChildren,
  PublicEPostVerifieradRoute: PublicEPostVerifieradRoute
};
const PublicLayoutRouteWithChildren = PublicLayoutRoute._addFileChildren(PublicLayoutRouteChildren);
const rootRouteChildren = {
  IndexRoute: IndexRoute,
  AppLayoutRoute: AppLayoutRouteWithChildren,
  PublicLayoutRoute: PublicLayoutRouteWithChildren,
  SplatRoute: SplatRoute
};
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)._addFileTypes();